<template>
    <div class="cookies" v-show="panelOpen">
        <h2 class="left-bullet">{{'w.cookies.panel-title'|t}}</h2>
        <p>{{'w.cookies.panel-intro'|t}}</p>
        <div v-if="settingsOpen">
            <ul class="cookies-list">
                <li v-for="cookie in cookies" :key="cookie.id">
                    <label>
                        <div class="cookie-info">
                            <span class="cookie-info-title">{{ `w.cookies.${cookie.name}-cookies-title` | t }}</span>
                            <span class="cookie-info-description">{{ `w.cookies.${cookie.name}-cookies-description` | t }}</span>
                        </div>
                        <input type="checkbox" v-model="cookie.allowed" :disabled="cookie.disabled" @change="toggleCookie(cookie.name)">
                    </label>
                </li>
            </ul>
        </div>
        <div class="cookies-actions">
            <button class="btn btn--revert" @click="acceptAllCookies"><span>{{'w.cookies.accept-all'|t}}</span></button>
            <button class="btn btn--revert" @click="refuseAllCookies"><span>{{'w.cookies.refuse-all'|t}}</span></button>
            <button class="btn-link" v-if="! settingsOpen" @click="openSettings"><span>{{'w.cookies.settings'|t}}</span></button>
            <button class="btn btn--revert" v-else @click="saveSettings"><span>{{'w.cookies.save'|t}}</span></button>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import { bootstrap } from 'vue-gtag'

export default {
    data() {
        return {
            panelOpen: true,
            settingsOpen: false,
            cookies: [
                {
                    id: 1, 
                    name: 'necessary', 
                    allowed: true, 
                    disabled: true,
                    init: function () {},
                    destroy: function () {},
                },
                {
                    id: 2, 
                    name: 'analytics', 
                    allowed: false, 
                    disabled: false,
                    init: () => {
                        bootstrap().then((gtag) => {
                            // all done!
                        })
                    },
                    destroy: () => {
                        var src = "https://www.googletagmanager.com/gtag/js?id=G-2VT76DC910";
                        var existingScript = document.querySelector(`script[src="${src}"]`);
                        if (existingScript) {
                            existingScript.parentNode.removeChild(existingScript);
                        }
                        this.removeCookiesStartWith(["_ga", "Google"]);
                    },
                },
                {
                    id: 3, 
                    name: 'facebook', 
                    allowed: false,
                    init: () => {
                        if (!window.fbq) {
                            var script = document.createElement('script');
                            script.src = "https://connect.facebook.net/en_US/fbevents.js";
                            script.onload = () => {
                                window.fbq('init', '5617223311657509');
                                window.fbq('track', 'PageView');
                            };
                            document.head.appendChild(script);
                        } else {
                            window.fbq('init', '5617223311657509');
                            window.fbq('track', 'PageView');
                        }
                    },
                    destroy: () => {
                        this.removeCookiesStartWith(["_fbp", "c_user", "datr", "dpr", "presence", "sb", "wd", "xs"], [".sonotron.lu", ".facebook.com"]);
                    },
                },
            ]
        };
    },
    methods: {
        acceptAllCookies() {
            this.cookies.forEach(cookie => {
                cookie.allowed = true;
                Cookies.set(cookie.name, true);
                if (cookie.init) {
                    cookie.init();
                }
            });

            this.closePanel();
        },
        refuseAllCookies() {
            this.cookies.forEach(cookie => {
                cookie.allowed = false;
                Cookies.remove(cookie.name);
                if (cookie.destroy) {
                    cookie.destroy();
                }
            });

            this.closePanel();
        },
        removeCookie(cookieName) {
            if (Cookies.get(cookieName)) {
                Cookies.remove(cookieName);
            }

            const cookie = this.cookies.find(cookie => cookie.name === cookieName);

            if (cookie) {
                cookie.allowed = false;
            }
        },
        removeCookiesStartWith(cookiesNameStartWith, domains) {
            var appCookies = document.cookie.split(";");
            for (var i = 0; i < appCookies.length; i++) {
                var appCookie = appCookies[i];
                var eqPos = appCookie.indexOf("=");
                var name = (eqPos > -1 ? appCookie.substr(0, eqPos) : appCookie).trim();

                if(cookiesNameStartWith && cookiesNameStartWith.length) {
                    cookiesNameStartWith.forEach(function (cookieNameStartWith) {
                        if (name.indexOf(cookieNameStartWith) == 0) {
                            if (domains && domains.length) {
                                domains.forEach(domain => {
                                Cookies.remove(name, { path: '', domain: domain });
                                });
                            }
                        }
                    }.bind(this));
                }
            }
        },
        toggleCookie(cookieName) {
            const cookie = this.cookies.find(cookie => cookie.name === cookieName);
            if (! cookie.allowed) {
                cookie.allowed = false;
                cookie.destroy();
                this.removeCookie(cookieName);
            } else {
                cookie.allowed = true;
                cookie.init();
                Cookies.set(cookieName, true);
            }
        },
        openSettings() {
            this.settingsOpen = true;
        },
        saveSettings() {
            this.settingsOpen = false;
            this.closePanel();
        },
        closePanel() {
            Cookies.set('cookies-close', true);
            this.panelOpen = false;
        }
    },
    mounted() {

        // Check if panel is open
        this.panelOpen = Cookies.get('cookies-close') ? false : true;

        this.cookies.forEach(cookie => {
            const cookieValue = Cookies.get(cookie.name);
            if (cookieValue && cookie.name !== 'necessary') {
                cookie.allowed = true;
                if (cookie.init) {
                    cookie.init();
                }
            }
        });
    }
};
</script>
